import { OneEmptyState } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

const RequisitionsPage = () => {
  return <OneEmptyState title={i18n.t('ats.routes.requisitions')} description="" emoji="📋" />
}

export default RequisitionsPage
